import get from 'lodash/get';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import FindSimilarModal from './FindSimilarModal';
import {
  isLoading as isLoadingSelector,
  data as dataSelector,
  itemsForDB as itemsForDBSelector,
  modalTitle as modalTitleSelector,
  itemsForAvailableDB as itemsForAvailableDBSelector,
  itemsForCurrentDB as itemsForCurrentDBSelector,
} from './FindSimilarModalSelectors';

import FindSimilarModalReducer from './FindSimilarModalReducer';
import { findSimilarModalReducerKey } from './FindSimilarModalConstants';
import { goTo, initialize, close } from './FindSimilarModalActions';

const mapStateToProps = (state, ownProps) => ({
  isLoading: isLoadingSelector(state),
  data: dataSelector(state),
  itemsForDB: itemsForDBSelector(state),
  modalTitle: modalTitleSelector(state),
  itemsForCurrentDB: itemsForCurrentDBSelector(state),
  itemsForAvailableDB: itemsForAvailableDBSelector(state),
  isIntegratedModal: get(ownProps, 'modalProps.isIntegratedModal'),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  goTo: (result) => dispatch(goTo(ownProps.closeCallback, result)),
  initialize: () => dispatch(initialize(ownProps.modalProps, ownProps.observer)),
  close: () => dispatch(close(ownProps.dismissCallback)),
});

export default compose(
  withReducer(findSimilarModalReducerKey, FindSimilarModalReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(FindSimilarModal);
